import * as React from "react";

import {toJst} from "../../../utils/date-util";
import {Dayjs} from "../../../utils/dayjs";

export const DateTimeText = (props: {time: Dayjs; format: string}) => (
    <>{toJst(props.time).format(props.format)}</>
);
